import { mapGetters } from 'vuex';
import { successMessage, errorMessage } from '@/utils/message.js';
import RegExp from '@/utils/regExp.js';
import UploadImage from '@/components/upload-image/index.vue';
import { companyFiles, villageFiles, comImagesForm, perRules, comRules, personFiles, perImagesForm, nonpersonFiles, nonperImagesForm } from './files.js';
import Bus from '../../bus.js';

export default {
  components: {
    UploadImage
  },
  data() {
    return {
      smsCodeShowCount: 60,
      smsCodeShowText: '获取验证码',
      imagesForm: {},
      codeForm: { // 短信验证码form
        verifyCode: '',
        assignorCode: ''
      },
      householdsTypeOr: 1, // 户口 2不展示户籍
      personFiles: [], // 个人影像资料
      perImagesForm: {}, // 个人影像资料
      form: {
        files: []
      },
      rules: {},
      codeRules: { // 短信验证码rules
        verifyCode: [
          { required: true, message: '请输入图片验证码', trigger: 'blur'}
        ],
        assignorCode: [
          { required: true, message: '请输入短信验证码', trigger: 'blur'}
        ]
      }
    };
  },
  computed: {
    ...mapGetters([
      'companyLegalInfo',
      'captchaImageSrc',
      'ticket',
      'userType',
      'isLegal',
      'assignorMobile',
      'personMobile'
    ])
  },
  created() {
    this.updateCaptchaImage();
    this.personFiles = nonpersonFiles;
    this.perImagesForm = nonperImagesForm;
    Bus.$on('emit', (householdsType) => {
      this.householdsTypeOr = householdsType;
    });
  },
  watch: {
    'householdsTypeOr'() {
      // 个人
      if(this.householdsTypeOr === 2) {
        this.personFiles = personFiles;
        this.perImagesForm = perImagesForm;
        this.initForm();
      } else {
        this.personFiles = nonpersonFiles;
        this.perImagesForm = nonperImagesForm;
        this.initForm();
      }
    }
  },
  mounted() {
    this.initForm();
  },
  methods: {

    // 手机验证码倒计时
    countDownOfSmsCode() {
      let _this = this;
      if (this.smsCodeShowCount >= 1) {
        _this.timer = setInterval(function() {
          _this.smsCodeShowCount--;
          _this.smsCodeShowText = _this.smsCodeShowCount + 'S';
          if (_this.smsCodeShowCount <= 0) {
            _this.smsCodeShowText = '请重新获取';
            _this.smsCodeShowCount = 60;
            clearInterval(_this.timer);
          }
        }, 1000);
      }
    },
    // 更新图片验证码
    updateCaptchaImage() {
      this.$store.dispatch('getCodeImage').then(() => {
      }, error => {
        if (error && error.reason) {
          errorMessage(error.reason);
        } else {
          errorMessage('更新验证码失败，请重试');
        }
      });
    },
    // 获取手机验证码
    getSmsCode() {
      var mobile = '';
      if(this.userType === 1) {
        mobile = this.personMobile;
        if (!mobile) {
          errorMessage('请先输入手机号码');
          return;
        }
      } else {
        mobile = this.isLegal?this.companyLegalInfo && this.companyLegalInfo.legalMobile:this.assignorMobile;
        if (!mobile) {
          errorMessage('请先输入被授权人手机号码');
          return;
        }
      }
      // const mobile = this.isLegal?this.companyLegalInfo && this.companyLegalInfo.legalMobile:this.assignorMobile;
      // if (!mobile) {
      //   errorMessage('请先输入被授权人手机号码');
      //   return;
      // }
      if (!RegExp.phone.test(mobile)) {
        errorMessage('请输入正确的手机号');
        return;
      }
      if (!this.codeForm.verifyCode) {
        errorMessage('请先输入图片验证码');
        return;
      }
      if (this.codeForm.verifyCode && this.codeForm.verifyCode.length !== 4) {
        errorMessage('请输入正确的图片验证码');
        return;
      }
      const form = {mobile: mobile, ticket: this.ticket, verifyCode: this.codeForm.verifyCode};
      if (this.smsCodeShowCount === 60) {
        this.smsCodeShowText = '发送中...';
        this.$store.dispatch('getSmsCode', form).then(res => {
          if (res.code === '0') {
            this.countDownOfSmsCode();
            successMessage('验证码发送成功');
          }
        }, error => {
          this.updateCaptchaImage();
          this.smsCodeShowText = '请重新获取';
          this.smsCodeShowCount = 60;
          if (error && error.reason) {
            errorMessage(error.reason);
          } else {
            errorMessage('获取验证码失败，请重试');
          }
        });
      }
    },
    // 是否展示被授权人图片上传
    showAuthorizerImage(item) {
      if ((item.projectFileType === 'ASSIGNOR_ID_CARD_FRONT' || item.projectFileType === 'ASSIGNOR_ID_CARD_BACK') && this.isLegal) {
        return false;
      }
      return true;
    },
    // 跳转授权委托书样例
    downExample() {
      window.open('/授权委托书样例.doc');
    },
    initForm() {
      if (this.userType === 1) {
        this.imagesForm = this.perImagesForm;
        this.form.files = this.personFiles;
        this.rules = perRules;
      } else if (this.userType === 2) {
        this.imagesForm = comImagesForm;
        this.form.files = companyFiles;
        this.form.files.map(v => {
          if (v.projectFileType === 'LICENSE_IMG') {
            v.title = '营业执照';
          }
        });
        this.rules = comRules;
        this.rules.LICENSE_IMG = [
          { required: true, message: '请上传营业执照', trigger: 'change'}
        ];
        this.rules.ASSIGNOR_BOOK = [
          { required: true, message: '请上传授权委托书', trigger: 'change'}
        ];
      } else if (this.userType === 3) {
        this.imagesForm = comImagesForm;
        this.form.files = villageFiles;
        this.form.files.map(v => {
          if (v.projectFileType === 'LICENSE_IMG') {
            v.title = '农村集体经济组织登记证';
          }
        });
        this.rules = comRules;
        this.rules.LICENSE_IMG = [
          { required: true, message: '请上传农村集体经济组织登记证', trigger: 'change'}
        ];
        this.rules.ASSIGNOR_BOOK = [
          { required: true, message: '请上传授权委托书', trigger: 'change'}
        ];
        // delete this.rules.ASSIGNOR_BOOK;
      }
    },
    uploadImage(index, type, event) {
      this.imagesForm[type] = event.length || null;
      this.form.files[index].filePaths = event;
    },
    validateForm () {
      let imagesFormIsValid = false;
      this.$refs['imagesForm'].validate(valid => {
        imagesFormIsValid = valid;
      });
      return imagesFormIsValid;
    },
    // 校验验证码
    validateCodeForm () {
      let codeFormIsValid = true;
      this.$refs['codeForm'] && this.$refs['codeForm'].validate(valid => {
        codeFormIsValid = valid;
      });
      return codeFormIsValid;
    }
  }

};
